import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import { SectionTitle } from '../Section';

export const TitleSubscribeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  ${mediaQuery(BREAKPOINTS.phone)} {
    justify-content: space-between;
  }
`;

export const Title = styled(SectionTitle)`
  margin-bottom: 0;
`;

export const Count = styled.h2`
  font-size: 14px;
  margin-bottom: 15px;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 32px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;
    gap: 24px;
  }
`;

export const Image = styled.div`
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  overflow: hidden;

  ${mediaQuery(BREAKPOINTS.tablet, 'min')} {
    width: 40%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mediaQuery(BREAKPOINTS.tablet, 'min')} {
    width: 60%;
  }
`;

export const DetailsCard = styled.div`
  margin-top: 24px;
  margin-bottom: 0;
  padding: 16px 24px;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
  border-radius: 16px;
`;
